export default "__VITE_ASSET__YGeo6FE7__"